import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

export function RestrictedRoutes({ children }) {
  const authReducer = useSelector((state) => state.authReducer);
  return !authReducer.isLogin === 'ACTIVE' ? (
    <Outlet />
  ) : (
    <Navigate to={'/user/dashboard'} />
  );
}
